module.exports = __webpack_public_path__ + "static/ConsumerProtectionAssociation-e103313f9d1f11eeb45fb85b13e41c50.gif";